import { alpha } from "@mui/material"

export default function useCellColors(isCheapestColumn, isMoreExpensiveColumn) {

	const borderColor = isCheapestColumn
		? 'success.light'
		: isMoreExpensiveColumn
			? 'error.light'
			: 'secondary.lighter'

	const hoverBorderColor = isCheapestColumn
		? 'success.main'
		: isMoreExpensiveColumn
			? "error.main"
			: 'secondary.light'

	const bgColor = isCheapestColumn
		? (theme) => alpha(theme.palette.success.main, 0.1)
		: isMoreExpensiveColumn
			? (theme) => alpha(theme.palette.error.main, 0.1)
			: 'transparent'


	return { bgColor, borderColor, hoverBorderColor }

}